<template>
  <a-card :bordered="false">
    <!-- 条件搜索 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('入驻审核.角色类型')">
              <a-select v-model="queryParam.workerType" allowClear @change="handleQuery">
                <a-select-option v-for="(item, index) in customDict.WorkerTypeEnum" :value="item.type" :key="index">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('入驻审核.审核状态')">
              <a-select v-model="queryParam.auditStatus" allowClear @change="handleQuery">
                <a-select-option v-for="(item, index) in auditStatusOptions" :value="item.type" :key="index">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('入驻审核.姓名')">
              <a-input v-model="queryParam.name" @pressEnter="handleQuery" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('入驻审核.用户信息')">
              <a-input v-model="queryParam.userInfo" @pressEnter="handleQuery" allow-clear :placeholder="$t('入驻审核.用户信息搜索提示')"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 数据表格 -->
    <a-table
      :loading="loading"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="pagination"
      @change="handleTableChange"
      :bordered="tableBordered"
    >
      <span slot="workerType" slot-scope="text, record">
        <a-tag :color="record.workerType === 1 ? 'blue' : record.workerType === 2 ? 'green' : 'orange'">
          {{ record.workerTypeName }}
        </a-tag>
      </span>
      <span slot="avatarImage" slot-scope="text, record">
        <a-avatar v-if="record.avatarImage" :src="record.avatarImage" :size="40" shape="square" />
        <a-avatar v-else :size="40" shape="square" icon="user" />
      </span>
      <template slot="userInfo" slot-scope="text, record">
        {{ $t('入驻审核.昵称') }}：{{ record.nickName || '-' }} <br/>
        {{ $t('入驻审核.手机号') }}：{{ record.mobile || '-' }} <br/>
      </template>
      <span slot="auditStatus" slot-scope="text, record">
        <a-tag :color="record.auditStatus === 0 ? 'orange' : record.auditStatus === 1 ? 'green' : 'red'">
          {{ record.auditStatusName }}
        </a-tag>
      </span>
      <span slot="depositStatus" slot-scope="text, record">
        <a-tag :color="record.depositStatus === 1 ? 'green' : 'red'">
          {{ record.depositStatusName }}
        </a-tag>
      </span>
      <span slot="workStatus" slot-scope="text, record">
        <a-tag :color="record.workStatus === 1 ? 'green' : 'gray'">
          {{ record.workStatusName }}
        </a-tag>
      </span>
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDetail(record)" v-hasPermi="['homeservice:worker:detail']">
          <a-icon type="eye" />{{$t('通用.按钮.详情')}}
        </a>
        <!-- 待审核：显示通过/拒绝 -->
        <template v-if="record.auditStatus === 0">
          <a-divider type="vertical" />
          <a @click="handleAudit(record, 1)" v-hasPermi="['homeservice:worker:pass']">
            <a-icon type="check" />{{$t('入驻审核.通过')}}
          </a>
          <a-divider type="vertical" />
          <a @click="handleAudit(record, 2)" v-hasPermi="['homeservice:worker:pass']">
            <a-icon type="close" />{{$t('入驻审核.拒绝')}}
          </a>
        </template>
        <!-- 已审核（通过/拒绝）：支持再次修改审核状态 -->
        <template v-else>
          <a-divider type="vertical" />
          <a @click="handleAudit(record, record.auditStatus)" v-hasPermi="['homeservice:worker:pass']">
            <a-icon type="edit" />{{$t('入驻审核.修改审核')}}
          </a>
        </template>
      </span>
    </a-table>

    <!-- 详情弹窗 -->
    <detail-form ref="detailForm" @ok="getList" />
    
    <!-- 审核弹窗 -->
    <audit-form ref="auditForm" @ok="getList" />
  </a-card>
</template>

<script>
import { pageWorker } from '@/api/homeworker/worker'
import { tableMixin } from '@/store/table-mixin'
import { mapGetters } from 'vuex'
import DetailForm from './modules/DetailForm'
import AuditForm from './modules/AuditForm'
import { AUDIT_STATUS_OPTIONS } from './auditStatus'

export default {
  name: 'HomeWorkerProfile',
  components: { DetailForm, AuditForm },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      total: 0,
      queryParam: {
        workerType: undefined,
        auditStatus: undefined,
        name: undefined,
        userInfo: undefined,
        pageNum: 1,
        pageSize: 10
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => this.$t('通用.文本.共') + ` ${total} ` + this.$t('通用.文本.条')
      },
      columns: [
        { title: this.$t('入驻审核.用户信息'), dataIndex: 'userInfo', scopedSlots: { customRender: 'userInfo' }, width: 180 },
        { title: this.$t('入驻审核.角色类型'), dataIndex: 'workerType', scopedSlots: { customRender: 'workerType' } },
        { title: this.$t('入驻审核.工装头像/大门照'), dataIndex: 'avatarImage', scopedSlots: { customRender: 'avatarImage' }, width: 140 },
        { title: this.$t('入驻审核.姓名'), dataIndex: 'name' },
        { title: this.$t('入驻审核.联系方式'), dataIndex: 'contactPhone' },
        { title: this.$t('入驻审核.地区'), dataIndex: 'province', customRender: (text, record) => `${record.province || ''}${record.city || ''}${record.district || ''}` },
        { title: this.$t('入驻审核.审核状态'), dataIndex: 'auditStatus', scopedSlots: { customRender: 'auditStatus' } },
        { title: this.$t('入驻审核.保证金状态'), dataIndex: 'depositStatus', scopedSlots: { customRender: 'depositStatus' } },
        { title: this.$t('入驻审核.工作状态'), dataIndex: 'workStatus', scopedSlots: { customRender: 'workStatus' } },
        { title: this.$t('入驻审核.申请时间'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' } },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, width: 200 }
      ],
    }
  },
  computed: {
    ...mapGetters(['customDict']),
    // 审核状态选项：不使用 customDict.AuditStatusEnum（后端同名枚举会互相覆盖），使用本地定义
    auditStatusOptions() {
      return AUDIT_STATUS_OPTIONS
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      const param = { ...this.queryParam }
      // userInfo 搜索框同时搜索昵称和手机号（OR关系）
      if (param.userInfo) {
        param.nickName = param.userInfo
        delete param.userInfo
      }
      pageWorker(param).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.pagination.total = response.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.pagination.current = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { pageNum: 1, pageSize: 10 }
      this.pagination.current = 1
      this.handleQuery()
    },
    handleTableChange(pagination) {
      this.queryParam.pageNum = pagination.current
      this.queryParam.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getList()
    },
    handleDetail(row) {
      this.$refs.detailForm.show(row.id)
    },
    handleAudit(row, auditStatus) {
      this.$refs.auditForm.show(row, auditStatus)
    }
  }
}
</script>
